import { styled } from 'linaria/react';

import { COLORS } from 'styles/constants';
import { StyledSearchIconWrapper as ImportIconWrapper } from '../RecentSearch/styled';

export const StyledSearchIconWrapper = styled(ImportIconWrapper)`
  background-color: ${({ isDark }) => (isDark ? COLORS.white[10] : COLORS.white.off[100])};
  border: none;
`;
